import React from 'react';
import { X, Trash2, AlertCircle, Pill } from 'lucide-react';

const MedicamentDeleteModal = ({ medicament, isOpen, onClose, onConfirm, loading }) => {
  if (!isOpen || !medicament) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="p-2 bg-red-100 rounded-full mr-3">
              <Trash2 className="h-6 w-6 text-red-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900">Supprimer le médicament</h3>
          </div>
          
          <div className="mb-6">
            <p className="text-gray-600 mb-4">
              Êtes-vous sûr de vouloir supprimer <strong>{medicament.name}</strong> ?
            </p>
            <div className="flex items-center p-3 bg-red-50 border border-red-200 rounded-lg">
              <AlertCircle className="h-5 w-5 text-red-600 mr-2" />
              <p className="text-sm text-red-800">
                Cette action est irréversible. Toutes les données associées seront supprimées.
              </p>
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              onClick={() => onConfirm(medicament.id)}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Suppression...' : 'Supprimer'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicamentDeleteModal;

